import type SchedulingAssistantState from './schema/SchedulingAssistantState';
import { createStore } from 'satcheljs';
import { createInitialSchedulingAssistantState } from '../utils/createInitialSchedulingAssistantState';

export const getStore = createStore<SchedulingAssistantState>(
    'schedulingAssistantStore',
    createInitialSchedulingAssistantState()
);
export default getStore;
